import React, { useRef } from "react";
import { GrFacebook } from "react-icons/gr";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import emailjs from "emailjs-com";
import './blog.css';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      "service_2tke4nl",
      "template_xbs8xrr",
      form.current,
      "csG3FQ0cPuQ2WcdCM"
    );
    e.target.reset();
    alert("Thanks! Our team will contact you soon.");
  };

  return (
    <section id="contact" className="gpt3__contact">
      <div className="gpt3__contact-header">
        <span className="gpt3__contact-tag">Get In Touch</span>
        <h2>Contact Us</h2>
      </div>

      <div className="gpt3__contact-container">
        {/* Contact Options */}
        <div className="gpt3__contact-options">
          <ContactCard
            Icon={MdOutlineMarkEmailRead}
            title="Email"
            subtitle="themindfitnesshub@gmail.com"
            link="https://mail.google.com/mail/u/0/#inbox?compose=CllgCJqSvWwQMSvKlZFDnrlgMNttnnHvXqlsSSvcJRkNjDgHRgSjmNknBPWpCqVdrtTxMBKncgB"
          />
          {/* <ContactCard
            Icon={GrFacebook}
            title="Facebook"
            subtitle="Vivek Verma"
            link="https://www.facebook.com/profile.php?id=100009629087144"
          /> */}
          <ContactCard
            Icon={BsWhatsapp}
            title="WhatsApp"
            subtitle="+91 9315427607"
            link="https://api.whatsapp.com/send?phone=9315427607"
          />
        </div>

        {/* Contact Form */}
        <form ref={form} onSubmit={sendEmail} className="gpt3__contact-form">
          <div className="gpt3__contact-form-group">
            <input
              type="text"
              name="name"
              placeholder="Your full name"
              required
            />
          </div>
          <div className="gpt3__contact-form-group">
            <input
              type="email"
              name="email"
              placeholder="Your email address"
              required
            />
          </div>
          <div className="gpt3__contact-form-group">
            <input
              type="tel"
              name="phone"
              placeholder="Your phone number"
            />
          </div>
          <div className="gpt3__contact-form-group">
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your requirements..."
              required
            />
          </div>
          <button type="submit" className="gpt3__contact-submit">
            Register Here
          </button>
        </form>
      </div>
    </section>
  );
}

const ContactCard = ({ Icon, title, subtitle, link }) => (
  <a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className="gpt3__contact-card"
  >
    <div className="gpt3__contact-card-icon">
      <Icon />
    </div>
    <div className="gpt3__contact-card-body">
      <h4>{title}</h4>
      <p>{subtitle}</p>
      <span>Send a message &rarr;</span>
    </div>
  </a>
);

export default Contact;
